module.exports = __webpack_public_path__ + "assets/config/zh-HK.json";